module.exports = __webpack_public_path__ + "static/media/checkbox.10262d28.svg";